export const AGENT_TABS = [
  'overview',
  'config',
  'permissions',
  'tools',
  'mcp',
  'triggers',
  'flows',
  'skills',
  'memory',
  'runs',
  'usage',
] as const;
export const SETTINGS_SECTIONS = [
  'providers',
  'models',
  'budgets',
  'members',
  'security',
  'audit',
  'channels',
  'integrations',
  'mcp',
  'knowledge',
  'company',
] as const;
export type SettingsSection = (typeof SETTINGS_SECTIONS)[number];
